module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_3009.5c434b51.png";